import { TabSection } from '../../../../../panels/entity-panels/tabs/tab-section';
import { TabIndented } from '../../../../../panels/entity-panels/tabs/tab-indented';
import { ScheduledEventDetailsSectionContent } from './scheduled-event-details-section-content';

export function ScheduledEventDetailsSection({
    receivedDateUtc,
}: {
    receivedDateUtc?: string;
}): React.ReactElement {
    return (
        <TabSection title="Scheduled Event Details">
            <TabIndented>
                <ScheduledEventDetailsSectionContent receivedDateUtc={receivedDateUtc} />
            </TabIndented>
        </TabSection>
    );
}
